// The staff PIN's shape (spec/07 §6.7; the contract's `SetStaffPinSchema`): six digits that are not one
// digit repeated (`111111`) nor a run up or down (`123456`, `987654`) — the first PINs anyone would try
// at a counter. The server refuses them all the same; this says why before anything is sent.

export const STAFF_PIN_LENGTH = 6;

export type StaffPinProblem = 'length' | 'repeated' | 'run' | 'mismatch';

/** Why a PIN and its confirmation cannot be set, or `undefined` when they can. */
export function staffPinProblem(pin: string, confirm: string): StaffPinProblem | undefined {
  if (!new RegExp(`^\\d{${STAFF_PIN_LENGTH}}$`).test(pin)) return 'length';
  const digits = [...pin].map(Number);
  if (digits.every((digit) => digit === digits[0])) return 'repeated';
  const steps = digits.slice(1).map((digit, index) => digit - (digits[index] ?? 0));
  if (steps.every((step) => step === 1) || steps.every((step) => step === -1)) return 'run';
  if (pin !== confirm) return 'mismatch';
  return undefined;
}
